<template>
  <div>
    <img :src="bg" alt="" />
    <div class="bt"></div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    bg: {
      type: String,
      default:
        'http://cdn.yxvzb.com/newWechat/image/quesheng/%E6%9C%8D%E5%8A%A1%E5%99%A8%E5%87%BA%E9%94%99@2x.png'
    }
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
img {
  width: 8rem;
  display: block;
  margin: 1rem auto;
}
</style>
